<template>
  <div>
    <div v-if="isMobile">
      <app-history
        v-for="index in history.length"
        :key="index"
        :index="index - 1"
        :item="history[index - 1]"
        :selectedItem="selectedItem"
        @clicked="onClickItem"
        @removeRequest="removeRequest"
        @callDownload="callDownloadFromCard"
        >.
      </app-history>
    </div>
    <div v-else>
      <v-data-table
        :items="history"
        item-key="Fserial"
        :headers="historyHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        show-expand
      >
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn
            class="grid"
            v-if="item.Removeable"
            color="red white--text"
            rounded
            @click="removeRequest(item.Fserial)"
          >
            حذف درخواست
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>توضیحات طلبه: </b>
            <span v-html="item.StudentComment"></span>
            <span v-html="' '"></span>
            <a v-if="item.HasStudentFile" @click="callDownload(item.Fserial)"
              >دریافت پیوست</a
            >
            <br />

            <br />
            <b>نظر واحد پذیرش مرکز مدیریت: </b>{{ item.ReceptionState }}.
            <span v-html="item.ReceptionComment"></span>

            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import History from "./History";
import Dialog from "@/components/Dialog";
import { removeMaritalRequest, downloadAttach } from "@/api/marital";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appHistory: History,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: -1,

      historyHeaders: [
        {
          text: "وضعیت",
          value: "StrState",
          width: "15%",
        },
        {
          text: "شناسه درخواست",
          value: "Fserial",
          width: "20%",
        },
        {
          text: "درخواست",
          value: "NkMarriage",
          width: "30%",
        },
        {
          text: "نام همسر",
          value: "HamsarFullName",
          width: "20%",
        },

        // {
        //   text: "تاریخ درخواست",
        //   value: "DDate",
        //   width: "15%",
        // },

        {
          text: "",
          value: "Removable",
          width: "15%",
          sortable: false,
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
    };
  },
  created() {
    this.$store.dispatch("getMaritalHistory");
  },
  computed: {
    history() {
      return this.$store.getters.maritalHistory;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    /**
     * expand khorooj
     */
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        var FileId = "";
        var fileHamsarId = "";
        for (var i = 0; i < this.history.length; i++) {
          if (this.history[i].Fserial == index) {
            FileId = this.history[i].SrlFile;
            fileHamsarId = this.history[i].SrlFileHamsar;
            break;
          }
        }
        removeMaritalRequest(index, FileId, fileHamsarId)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.$store.dispatch("getMaritalHistory");
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    callDownloadFromCard(data) {
      this.callDownload(data.index);
    },
    callDownload(index) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(index)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
